import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import Loader from '../../Loader/Loader.js';
import { isTouchDevice } from '../../Util/is-touch-device.js';

const handleOnClear = (ref, callback)=>{
    var ref1, ref2;
    callback();
    (ref1 = ref) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.focus();
};
const handleOnSubmit = (ref, callback)=>{
    callback === null || callback === void 0 ? void 0 : callback();
    if (isTouchDevice() === false) {
        var ref3, ref4;
        (ref3 = ref) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.current) === null || ref4 === void 0 ? void 0 : ref4.focus();
    }
};
const Input = /*#__PURE__*/ React__default.forwardRef((_param, ref)=>{
    var { className , count , cursor , disabled , isInvalid , isListSuggestionsOpen , isValid , labels , loading , name , onBlur , onChange , onClear , onClick , onSubmit , placeholder , showClearButton =false , submitIcon , type , value  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "count",
        "cursor",
        "disabled",
        "isInvalid",
        "isListSuggestionsOpen",
        "isValid",
        "labels",
        "loading",
        "name",
        "onBlur",
        "onChange",
        "onClear",
        "onClick",
        "onSubmit",
        "placeholder",
        "showClearButton",
        "submitIcon",
        "type",
        "value"
    ]);
    const status = React__default.useMemo(()=>isListSuggestionsOpen && count > 0 ? `${count} ${labels.availableResultsScreenReaderHint}` : labels.noAvailableResultsScreenReaderHint
    , [
        count,
        labels,
        isListSuggestionsOpen
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('autocomplete-input', className)
    }), /*#__PURE__*/ React__default.createElement("span", {
        id: `${name}-autocomplete-description`,
        className: "autocomplete-input__hint"
    }, labels.inputScreenReaderHint), status && /*#__PURE__*/ React__default.createElement("span", {
        role: "status",
        "aria-live": "assertive",
        className: "autocomplete-input__hint--hidden"
    }, status), /*#__PURE__*/ React__default.createElement("input", {
        "aria-activedescendant": cursor < 0 ? undefined : `autocomplete-suggestion-item-${cursor}`,
        "aria-autocomplete": "both",
        "aria-describedby": `${name}-autocomplete-description`,
        "aria-expanded": isListSuggestionsOpen,
        "aria-label": name,
        "aria-owns": `${name}-suggestions`,
        "aria-controls": `${name}-suggestions`,
        autoComplete: "off",
        className: classnames('autocomplete-input__input', {
            'autocomplete-input__input--extra-padding': showClearButton || loading,
            _is_invalid: isInvalid,
            _is_valid: isValid
        }),
        "data-t": name,
        disabled: disabled,
        id: name,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onClick: onClick,
        placeholder: placeholder,
        ref: ref,
        role: "combobox",
        type: type,
        value: value,
        "aria-invalid": !isValid
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "autocomplete-input__button-wrapper"
    }, loading ? /*#__PURE__*/ React__default.createElement(Loader, {
        className: "autocomplete-input__loader"
    }) : showClearButton && /*#__PURE__*/ React__default.createElement("button", {
        "aria-label": labels.clearButtonScreenReaderHint,
        type: "button",
        onClick: ()=>handleOnClear(ref, onClear)
        ,
        className: "autocomplete-input__button autocomplete-input__button--clear"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "clear"
    })), submitIcon && /*#__PURE__*/ React__default.createElement("button", {
        "aria-label": labels.submitButtonScreenReaderHint,
        type: "button",
        onClick: ()=>handleOnSubmit(ref, onSubmit)
        ,
        className: "autocomplete-input__button autocomplete-input__button--submit"
    }, submitIcon)));
});
var Input$1 = Input;

export { Input$1 as default };
//# sourceMappingURL=Input.js.map
